<div #container class="container">
  <ng-container *ngFor="let vod of vods; let $index = index">
    <div
      class="vod-card htv-selectable htv-autofocus {{ $index === 0 ? 'htv-focus' : '' }}"
      (focus)="focusVOD(vod)"
      (click)="openVOD(vod)"
      tabindex="-1">
      <div class="vod-card__inner">
        <ng-container *ngIf="vod.thumbnailUrl">
          <img class="vod-card__thumbnail" [src]="vod.thumbnailUrl" alt="" />
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
